import React from 'react'

const AddRemarkModalUI = ({
  item,
  remark,
  onRemarkChange,
  onSubmitClick,
  onCancelClick,
  submitting,
  successMsg,
  errorList
}) => {
  return (
    <div className="modal-backdrop" style={backdropStyle}>
      <div className="modal-content" style={modalStyle}>
        <h3 style={{ marginTop: 0 }}>Add/Edit Remark</h3>

        {successMsg && (
          <div style={{
            color: 'green',
            marginBottom: '15px',
            padding: '10px',
            backgroundColor: '#d4edda',
            borderRadius: '4px',
            border: '1px solid #c3e6cb'
          }}>
            {successMsg}
          </div>
        )}

        {errorList && errorList.length > 0 && (
          <div style={{
            color: '#721c24',
            marginBottom: '15px',
            padding: '10px',
            backgroundColor: '#f8d7da',
            borderRadius: '4px',
            border: '1px solid #f5c6cb'
          }}>
            <strong>Error(s):</strong>
            <ul style={{ marginTop: '5px', marginBottom: '0', paddingLeft: '20px' }}>
              {errorList.map((err, idx) => (
                <li key={idx}>{err}</li>
              ))}
            </ul>
          </div>
        )}

        {item && (
          <div style={{
            fontSize: '13px',
            color: '#6c757d',
            marginBottom: '15px',
            padding: '8px',
            backgroundColor: '#f8f9fa',
            borderRadius: '4px'
          }}>
            <strong>Item:</strong> {item.title}
          </div>
        )}

        <div style={{ marginBottom: '20px' }}>
          <label style={{
            display: 'block',
            marginBottom: '8px',
            fontWeight: '600',
            color: '#495057'
          }}>
            Remark:
          </label>
          <textarea
            value={remark}
            onChange={(e) => onRemarkChange(e.target.value)}
            placeholder="Enter your remark here..."
            disabled={submitting}
            style={{
              width: '100%',
              minHeight: '120px',
              padding: '10px',
              fontSize: '14px',
              border: '1px solid #ced4da',
              borderRadius: '4px',
              resize: 'vertical',
              fontFamily: 'inherit'
            }}
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
          <button
            onClick={onCancelClick}
            disabled={submitting}
            style={cancelButtonStyle}
          >
            Cancel
          </button>
          <button
            onClick={onSubmitClick}
            disabled={submitting}
            style={submitButtonStyle}
          >
            {submitting ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </div>
    </div>
  )
}

const backdropStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000
}

const modalStyle = {
  backgroundColor: 'white',
  borderRadius: '8px',
  padding: '24px',
  minWidth: '500px',
  maxWidth: '600px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  maxHeight: '90vh',
  overflowY: 'auto'
}

const buttonStyle = {
  padding: '10px 20px',
  fontSize: '14px',
  cursor: 'pointer',
  border: 'none',
  borderRadius: '4px',
  fontWeight: '500',
  transition: 'all 0.2s'
}

const submitButtonStyle = {
  ...buttonStyle,
  backgroundColor: '#28a745',
  color: '#fff'
}

const cancelButtonStyle = {
  ...buttonStyle,
  backgroundColor: '#6c757d',
  color: '#fff'
}

export default AddRemarkModalUI